// @flow
/**
 * constants for paypal features
 */
export const BUY = 'buy'
export const GIFT = 'gift'
export const INVOICE = 'invoice'
export const MASS_PAYMENT = 'massPayment'
export const POOLS = 'pools'
export const PPME = 'ppme'
export const SELLER = 'seller'
export const REQUEST = 'request'
export const SEND = 'send'
export const XB = 'xb'
export const XB_BIZ = 'xbBiz'
export const REQUEST_GROUP = 'requestGroup'
export const SPLIT = 'split'
export const PPDG = 'ppdg'
export const DONATION = 'donation'
export const MESSAGES = 'messages'
export const GROUPS = 'groups'
